export const AUDIENCE_TYPES = ['FEMALE_ONLY', 'MALE_ONLY', 'UNISEX'];

export const AUDIENCE_BADGE_CLASS = {
  FEMALE_ONLY: 'bg-rose-500/15 text-rose-600 dark:text-rose-300',
  MALE_ONLY: 'bg-sky-500/15 text-sky-600 dark:text-sky-300',
  UNISEX: 'bg-emerald-500/15 text-emerald-700 dark:text-emerald-300',
};
